import { render, staticRenderFns } from "./JgpCheckbox.vue?vue&type=template&id=2ff06897&"
import script from "./JgpCheckbox.vue?vue&type=script&lang=js&"
export * from "./JgpCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports